// extracted by css-extract-rspack-plugin
export default {"staffControlRow":"_tm1_6mtNAgE9GwY","downloadBtn":"s9RcbhY58RUzYmRf"};